import React from "react";
import {Linking, Platform, StyleSheet, TouchableOpacity, View} from "react-native";
import PtText from "../core/pt-text/pt-text";
import {getTranslation} from "../../helpers/getTranslation";
import {styleVars} from "../../app-style-vars";
import {getSubdomain} from "../../helpers/getSubdomain";
import getConfig from "../../environment";

const hybrisBase = getConfig()?.hybrisBaseUrl.replace(/{subdomain}/g, getSubdomain());
const imprintUrl = `${hybrisBase}/imprint`;

export default function PtImprint(props) {

  const useInternalPage = props.useInternalLink || false;

  const openImprint = () => {
    if(useInternalPage) {
      props.navigation.navigate('Imprint');
    } else {
      if(Platform.OS === 'web') {
        window.open(imprintUrl)
      } else {
        Linking.openURL(imprintUrl);
      }
    }
  };

  return (
    <View style={styles.footerLinkContainer}>
      <TouchableOpacity onPress={() => openImprint()}>
        <PtText style={styles.footerLinkText}>{getTranslation('footer.imprint.link.text')}</PtText>
      </TouchableOpacity>
    </View>
  )
}

const styles = StyleSheet.create({
  footerLinkContainer: {
    paddingHorizontal: styleVars.rem(1),
    paddingVertical: styleVars.rem(.5),
    marginBottom: styleVars.rem(.5),
  },
  footerLinkText: {
    fontSize: styleVars.rem(.875),
    color: styleVars.boschDarkBlue,
  },
});
